// router/index.js

import {createRouter, createWebHistory} from "vue-router"

import routeComponentMapping from '@/router/autoRouteMapping' // autoRouteMapping에서 생성된 매핑 객체를 가져옵니다.
let lang = location.pathname.split('/')[1] ? location.pathname.split('/')[1] : 'kr';
const langArr = ['kr', 'en', 'ru', 'mn', 'ar', 'zh'];
if (!langArr.includes(lang)) lang = 'kr';

import Search from '../views/kr/search/SearchView.vue';

const staticRoutes = [
    {
        path: '/:lang/main',
        name: 'main',
        component: () => {
            // switch (store.getters.getHost) {
            //     case "aorta":
            return import(`@/views/${lang}/main/MainView.vue`);
            // }
        },
        children: [
            {
                path: '/',
                component: () => {
                    return import(`@/views/${lang}/main/MainView.vue`);
                }
            }
        ]
    },
    {
        path: '/common/checkplusSuccess',
        name: 'checkplusSuccess',
        component: () => import('../views/common/CheckplusSuccess')
    },
    {
        path: '/common/checkplusFail',
        name: 'checkplusFail',
        component: () => import('../views/common/CheckplusFail')
    },

    {
        path: '/sample',
        name: 'sample',
        component: () => import('../views/sample/SampleView')
    },
    {
        path: '/work',
        name: 'work',
        component: () => import('../views/sample/WorkView.vue')
    },
    // board, content, program manager view
    {
        path: '/:lang',
        name: 'contain',
        component: () => import('@/views/manager/ContainView.vue'),
        alias: ['/:lang/:path1', '/:lang/:path1/:path2', '/:lang/:path1/:path2/:path3', '/:lang/:path1/:path2/:path3/:path4']
    },
    // 퍼블리싱
    {
        path: '/pub/:path1',
        name: 'publishing',
        component: () => import('@/views/pubView.vue'),
        alias: ['/pub/:path1/:path2','/pub/:path1/:path2/:path3','/pub/:path1/:path2/:path3/:path4']
    },
    // {
    //     path: '/pub/심뇌혈관/:path1',
    //     name: 'publishing2',
    //     component: () => import('@/views/pubView.vue'),
    //     alias: ['/pub/:path1/:path2']
    // },
    // {
    //     path: '/pub/엄마아기병원/:path1',
    //     name: 'publishing3',
    //     component: () => import('@/views/pubView.vue'),
    //     alias: ['/pub/:path1/:path2']
    // },
    {
        path: '/kr/search',
        name: 'search',
        component: Search
    },

];

const routes = Object.keys(routeComponentMapping).map(path => ({
    path, // 매핑 객체에서 정의된 경로
    component: () => import(routeComponentMapping[path]) // 해당 경로에 매핑된 컴포넌트를 동적으로 로드
}))

routes.push(...staticRoutes)

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL), // BASE_URL 환경 변수를 사용하여 히스토리 생성
    routes,
    scrollBehavior() {
        return {top: 0} // 페이지 이동 시 스크롤 위치를 맨 위로
    },
})

export default router